export interface Movie {
  id: number;
  title: string;
  subtitle: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  subcategory: string;
  year: number;
  rating: number;
  image: string;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  language: string;
  duration: string;
  updateInfo: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  viewCount: number;
  content: string;
}

export const allMovies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    subtitle: 'The Wandering Earth 3',
    category: 'movie',
    subcategory: '科幻',
    year: 2025,
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20massive%20space%20engines%20propelling%20Earth%20through%20cosmos%2C%20dramatic%20orange%20and%20blue%20nebula%20background%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20photorealistic%20CGI%20style&width=800&height=450&seq=movie-poster-01&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%2C%20astronaut%20in%20space%20suit%20standing%20on%20frozen%20Earth%20surface%2C%20giant%20planet%20Jupiter%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20movie%20poster%20style%2C%20deep%20blue%20and%20orange%20tones&width=600&height=900&seq=movie-cover-01&orientation=portrait',
    description: '太阳急速老化，持续膨胀，地球面临被吞没的危机。人类再次启动行星发动机，踏上未知的星际之旅。这一次，他们将面对更艰难的抉择与挑战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '173分钟',
    updateInfo: '2025年贺岁档热映中',
    tags: ['硬核科幻', '国产巨制', '刘慈欣', '视觉盛宴'],
    isHot: true,
    isNew: true,
    viewCount: 8950000,
    content: `<h3>影片简介</h3>
<p>《流浪地球3》是由郭帆执导，吴京、刘德华领衔主演的科幻灾难电影，改编自刘慈欣同名小说。该片延续了前作的故事线，讲述了太阳急速老化膨胀，地球面临被吞没的危机，人类再次启动行星发动机，展开一场惊心动魄的星际逃亡之旅。</p>

<h3>剧情梗概</h3>
<p>在《流浪地球2》的故事之后，地球已经成功脱离太阳系。然而，新的危机接踵而至——行星发动机出现未知故障，地木引力平衡被打破。面对生死存亡，联合政府内部产生了严重分歧。以刘培强（吴京 饰）为代表的一派主张继续前行，而另一派则主张返回太阳系。在这场关乎人类命运的博弈中，每个人都将面临艰难的抉择。</p>

<h3>幕后制作</h3>
<p>影片历时三年拍摄，制作团队超过3000人，特效镜头占比达到90%以上。为了更好地呈现科幻效果，剧组搭建了多个1:1实景模型，并采用了最新的虚拟拍摄技术。郭帆导演表示，第三部将在视觉和情感上都达到新的高度。</p>

<h3>观众评价</h3>
<p>"国产科幻的巅峰之作！视觉效果震撼，情感内核更加丰富。"</p>
<p>"相比前两部，《流浪地球3》在叙事和人物塑造上有了质的飞跃。"</p>
<p>"吴京和刘德华的演技碰撞太精彩了，每一场戏都让人热血沸腾。"</p>`,
  },
  {
    id: 2,
    title: '满江红',
    subtitle: 'Full River Red',
    category: 'movie',
    subcategory: '历史',
    year: 2023,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20at%20night%20with%20red%20lanterns%20hanging%2C%20soldiers%20in%20Song%20Dynasty%20armor%20marching%20through%20narrow%20alleyways%2C%20dramatic%20chiaroscuro%20lighting%2C%20cinematic%20historical%20drama%20style&width=800&height=450&seq=movie-poster-02&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%2C%20warriors%20in%20ancient%20Song%20Dynasty%20costume%20standing%20in%20courtyard%2C%20red%20lanterns%20and%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20film%20poster%20design%2C%20warm%20red%20tones&width=600&height=900&seq=movie-cover-02&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。小兵张大与亲兵营副统领孙均在机缘巧合下被裹挟进一场巨大的阴谋。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '159分钟',
    updateInfo: '票房突破45亿',
    tags: ['悬疑', '历史', '张艺谋', '喜剧元素'],
    isHot: true,
    isNew: false,
    viewCount: 12500000,
    content: `<h3>影片简介</h3>
<p>《满江红》是张艺谋执导的一部悬疑喜剧电影。影片将故事背景设定在南宋绍兴年间，围绕岳飞死后的一桩神秘案件展开，融合了悬疑、喜剧、历史等多种元素。</p>

<h3>剧情梗概</h3>
<p>南宋绍兴年间，在岳飞死后第四年，秦桧（雷佳音 饰）率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大（沈腾 饰）与亲兵营副统领孙均（易烊千玺 饰）被卷入其中，被迫在有限的时间内找到凶手和信件。随着调查的深入，一个惊天秘密逐渐浮出水面。</p>

<h3>影片特色</h3>
<p>张艺谋在这部作品中巧妙融合了悬疑与喜剧元素，让观众在紧张刺激的调查过程中不时发出笑声。影片全程在一个封闭的院落中展开，通过精巧的叙事结构和演员精湛的表演，营造出层层递进的悬疑氛围。</p>

<h3>观众评价</h3>
<p>"沈腾和易烊千玺的组合太绝了，一个负责搞笑一个负责帅。"</p>
<p>"张艺谋的转型之作，悬疑感和节奏感都把握得很好。"</p>
<p>"结尾那首《满江红》朗诵太震撼了，直接泪目。"</p>`,
  },
  {
    id: 3,
    title: '消失的她',
    subtitle: 'Lost in the Stars',
    category: 'movie',
    subcategory: '悬疑',
    year: 2023,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20tropical%20island%20resort%20at%20sunset%2C%20empty%20beach%20chair%20facing%20ocean%2C%20dark%20clouds%20gathering%2C%20suspenseful%20atmosphere%2C%20cinematic%20thriller%20aesthetic%2C%20moody%20teal%20and%20coral%20tones&width=800&height=450&seq=movie-poster-03&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20movie%20poster%20with%20woman%20silhouette%20on%20beach%20at%20sunset%2C%20half%20face%20hidden%20in%20shadow%2C%20tropical%20ocean%20background%2C%20mysterious%20and%20thrilling%20vibe%2C%20film%20poster%20style%2C%20warm%20golden%20and%20dark%20blue%20contrast&width=600&height=900&seq=movie-cover-03&orientation=portrait',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失，当他苦寻无果之时，妻子再次现身，何非却坚持眼前的陌生女人并非妻子。',
    director: '崔睿、刘翔',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '121分钟',
    updateInfo: '口碑爆棚悬疑佳作',
    tags: ['悬疑', '反转', '犯罪', '高能结局'],
    isHot: true,
    isNew: false,
    viewCount: 10200000,
    content: `<h3>影片简介</h3>
<p>《消失的她》是一部扣人心弦的悬疑犯罪电影。影片讲述了一对夫妻在海外度假时发生的离奇失踪案，通过层层反转的叙事，揭示了一个令人震惊的真相。</p>

<h3>剧情梗概</h3>
<p>何非（朱一龙 饰）和妻子李木子（文咏珊 饰）前往东南亚某海岛度假，庆祝结婚周年。然而一觉醒来，妻子竟离奇消失。何非四处求助，却无人相信他的说法。更诡异的是，一名陌生女子突然出现，自称是他的妻子李木子，而所有人——包括酒店员工和警察——都相信她的身份。陷入绝境的何非，只能求助于当地金牌律师陈麦（倪妮 饰），两人联手展开调查，却意外揭开了一个更加骇人的秘密。</p>

<h3>影片亮点</h3>
<p>影片以多重视角叙事，每个角色的讲述都存在疑点。观众在被引导着一步步接近真相的过程中，会经历多次反转，直到最后一刻才恍然大悟。朱一龙和倪妮的演技对手戏令人拍案叫绝。</p>

<h3>观众评价</h3>
<p>"全片无尿点！最后二十分钟的反转一个接一个，看得我头皮发麻。"</p>
<p>"朱一龙的演技已经封神了，眼神里的层次感太丰富。"</p>
<p>"年度最佳悬疑片实至名归，建议不要看剧透直接去看。"</p>`,
  },
  {
    id: 4,
    title: '孤注一掷',
    subtitle: 'No More Bets',
    category: 'movie',
    subcategory: '犯罪',
    year: 2023,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Dark%20cyber%20crime%20office%20with%20rows%20of%20computer%20screens%20glowing%2C%20flickering%20neon%20lights%20in%20cramped%20room%2C%20oppressive%20atmosphere%2C%20crime%20thriller%20aesthetic%2C%20gritty%20realistic%20style&width=800&height=450&seq=movie-poster-04&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20multiple%20characters%20faces%20arranged%20like%20wanted%20posters%2C%20dark%20red%20and%20black%20color%20scheme%2C%20digital%20code%20elements%2C%20intense%20dramatic%20style%2C%20film%20poster%20design&width=600&height=900&seq=movie-cover-04&orientation=portrait',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。他们能否逃出生天？',
    director: '申奥',
    actors: ['张艺兴', '金晨', '王传君', '王大陆', '周也'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '130分钟',
    updateInfo: '暑期档票房冠军',
    tags: ['犯罪', '反诈', '现实题材', '惊悚'],
    isHot: true,
    isNew: false,
    viewCount: 13800000,
    content: `<h3>影片简介</h3>
<p>《孤注一掷》是国内首部揭露境外网络诈骗全产业链内幕的犯罪电影。影片取材自上万起真实诈骗案例，通过程序员和模特的视角，展现了境外诈骗工厂的残酷真相。</p>

<h3>剧情梗概</h3>
<p>程序员潘生（张艺兴 饰）和模特安娜（金晨 饰）被海外高薪招聘信息所吸引，怀揣着对美好生活的向往，踏上了前往异国的旅程。然而等待他们的，却是一个精心设计的陷阱。他们被关进了境外诈骗工厂，被迫从事网络诈骗活动。在这里，他们遇到了形形色色的受害者，也见识到了诈骗集团头目的残暴手段。为了活命，潘生和安娜不得不开始策划一场惊心动魄的逃亡。</p>

<h3>社会意义</h3>
<p>影片以其真实震撼的内容引发了全社会对网络诈骗问题的关注和讨论。许多观众表示，看完电影后对"高薪招聘"等诱惑有了更强的警惕性。影片被多家媒体评为"2023年最具社会影响力的电影"。</p>

<h3>观众评价</h3>
<p>"看完直接给家里人全打了电话，提醒他们小心诈骗。"</p>
<p>"王传君演的诈骗头目太吓人了，演技炸裂。"</p>
<p>"这么有社会责任感的电影，值得每个人去看看。"</p>`,
  },
  {
    id: 5,
    title: '长安三万里',
    subtitle: 'Chang An',
    category: 'movie',
    subcategory: '动画',
    year: 2023,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20Chinese%20city%20landscape%20at%20sunset%2C%20traditional%20Chinese%20architecture%20with%20curved%20roofs%2C%20golden%20light%20illuminating%20palace%20walls%2C%20ink%20wash%20painting%20style%2C%20poetic%20atmosphere&width=800&height=450&seq=movie-poster-05&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20Tang%20Dynasty%20style%2C%20poet%20on%20horseback%20riding%20toward%20distant%20palace%2C%20traditional%20ink%20painting%20aesthetic%2C%20warm%20golden%20sunset%20colors%2C%20elegant%20artistic%20film%20poster&width=600&height=900&seq=movie-cover-05&orientation=portrait',
    description: '安史之乱爆发后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。',
    director: '谢君伟、邹靖',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '168分钟',
    updateInfo: '国产动画里程碑之作',
    tags: ['动画', '历史', '唐诗', '国风美学'],
    isHot: true,
    isNew: false,
    viewCount: 7600000,
    content: `<h3>影片简介</h3>
<p>《长安三万里》是追光动画"新文化"系列的开篇之作，以唐代诗人高适的视角，讲述了他与李白跨越数十年的深厚友谊，以及大唐由盛转衰的历史变迁。</p>

<h3>剧情梗概</h3>
<p>安史之乱爆发后数年，吐蕃大军入侵西南，剑南西川节度使高适交战不利，长安岌岌可危。困守孤城的高适，向监军太监回忆起自己与李白的一生往事。从鲜衣怒马的少年相遇，到各自跌宕起伏的人生轨迹，两人见证了开元盛世的繁华，也经历了安史之乱的动荡。影片通过高适的回忆，展现了李白、杜甫、王维等一大批唐代诗人群像，以及他们留下的千古诗篇。</p>

<h3>艺术特色</h3>
<p>影片以中国传统水墨画风为基础，融合了现代3D动画技术。片中共出现了48首经典唐诗，每一首诗的呈现都配有独特的视觉画面。最后李白吟诵《将进酒》的场景被誉为"国漫史上最美画面"。</p>

<h3>观众评价</h3>
<p>"中国动画终于讲好了中国故事！每一帧都是一幅画。"</p>
<p>"看完想把唐诗三百首重新背一遍，文化自信油然而生。"</p>
<p>"陪着孩子看的，结果我自己哭了好几次，太感动了。"</p>`,
  },
  {
    id: 6,
    title: '狂飙',
    subtitle: 'The Knockout',
    category: 'tv',
    subcategory: '犯罪',
    year: 2023,
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=Two%20men%20in%20dark%20suits%20facing%20each%20other%20in%20rainy%20street%20at%20night%2C%20police%20car%20lights%20reflecting%20on%20wet%20pavement%2C%20crime%20drama%20atmosphere%2C%20cinematic%20noir%20style&width=800&height=450&seq=movie-poster-06&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20men%20standing%20back%20to%20back%2C%20one%20in%20police%20uniform%20one%20in%20black%20suit%2C%20dark%20atmospheric%20lighting%2C%20dramatic%20tension%2C%20film%20poster%20design&width=600&height=900&seq=movie-cover-06&orientation=portrait',
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开长达二十年的生死较量，全景式展现扫黑除恶的艰辛历程。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '39集',
    updateInfo: '现象级爆款剧集',
    tags: ['犯罪', '扫黑', '张颂文', '必看神剧'],
    isHot: true,
    isNew: true,
    viewCount: 25600000,
    content: `<h3>剧集简介</h3>
<p>《狂飙》是一部现象级的扫黑除恶题材电视剧。该剧以一线刑警安欣的视角，讲述了横跨二十年的扫黑故事，展现了中国扫黑除恶斗争的艰辛与决心。</p>

<h3>剧情梗概</h3>
<p>故事从2000年开始，年轻刑警安欣（张译 饰）在调查一起案件时，结识了鱼贩高启强（张颂文 饰）。彼时的高启强还只是一个被欺负的小人物。然而在之后的二十年里，高启强一步步走上了犯罪道路，建立起庞大的黑恶势力网络。安欣则始终坚守初心，在经历了无数次挫折与危险后，最终将高启强及其犯罪集团绳之以法。</p>

<h3>人物塑造</h3>
<p>《狂飙》之所以能成为现象级爆款，很大程度上归功于其出色的人物塑造。高启强从一个底层鱼贩到黑帮老大的转变过程，被张颂文演绎得入木三分，令人既恨其罪行又叹其命运。安欣二十年如一日的坚守，则让观众看到了正义的力量。</p>

<h3>观众评价</h3>
<p>"年度最佳国产剧，没有之一。张颂文的演技封神了。"</p>
<p>"看完狂飙，感觉国产剧终于有救了。剧本、导演、演员都在线。"</p>
<p>"高启强的角色太有魅力了，让人又爱又恨，张颂文拿视帝实至名归。"</p>`,
  },
  {
    id: 7,
    title: '三体',
    subtitle: 'Three-Body',
    category: 'tv',
    subcategory: '科幻',
    year: 2023,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20radio%20telescope%20array%20under%20starry%20night%20sky%2C%20cosmic%20background%20with%20three%20suns%2C%20sci-fi%20mystery%20atmosphere%2C%20cinematic%20scale%2C%20cool%20blue%20and%20purple%20cosmic%20tones&width=800&height=450&seq=movie-poster-07&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%20with%20mysterious%20cosmic%20signal%20waves%20rippling%20across%20starry%20sky%2C%20silhouette%20of%20scientist%20facing%20unknown%2C%20deep%20space%20background%2C%20intellectual%20thriller%20style&width=600&height=900&seq=movie-cover-07&orientation=portrait',
    description: '纳米科学家汪淼被警官史强带入一个神秘组织"科学边界"，由此揭开了一个涉及外星文明的巨大秘密。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '30集',
    updateInfo: '刘慈欣原著改编巨制',
    tags: ['科幻', '硬核', '刘慈欣', '现象级'],
    isHot: true,
    isNew: false,
    viewCount: 18900000,
    content: `<h3>剧集简介</h3>
<p>《三体》改编自刘慈欣同名科幻小说，是中国科幻电视剧的里程碑之作。该剧以严谨的科学态度和震撼的视觉效果，将这部获得雨果奖的科幻巨著搬上了荧屏。</p>

<h3>剧情梗概</h3>
<p>2007年，纳米科学家汪淼（张鲁一 饰）被警官史强（于和伟 饰）带入一个名为"科学边界"的神秘组织。在这里，他发现全球顶尖科学家正在相继自杀，而这一切都与一款名为《三体》的神秘游戏有关。随着调查的深入，汪淼逐渐揭开了一个惊天的秘密：一个位于三颗恒星系统中的外星文明，正在向地球进发，人类的命运由此被彻底改变。</p>

<h3>制作水准</h3>
<p>《三体》的制作投入超过4亿人民币，特效团队来自全球顶尖公司。剧中的三体游戏世界、古筝行动、智子展开等经典场景，都以极高的还原度呈现。尤其是"古筝行动"一集，被广泛认为是国产电视剧特效的最高水准。</p>

<h3>观众评价</h3>
<p>"作为原著粉，非常满意！还原度很高，于和伟的史强绝了。"</p>
<p>"虽然有些科学概念不太好理解，但整体节奏和氛围都很到位。"</p>
<p>"国产科幻终于站起来了，期待第二部黑暗森林。"</p>`,
  },
  {
    id: 8,
    title: '繁花',
    subtitle: 'Blossoms Shanghai',
    category: 'tv',
    subcategory: '年代',
    year: 2024,
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20Nanjing%20Road%20at%20night%20with%20neon%20signs%20and%20crowded%20streets%2C%20vintage%20cars%20and%20fashionable%20people%2C%20retro%20Chinese%20city%20glamour%2C%20warm%20golden%20tones&width=800&height=450&seq=movie-poster-08&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20poster%2C%20elegant%20man%20in%201990s%20Shanghai%20style%20suit%2C%20neon%20city%20lights%20background%2C%20nostalgic%20retro%20aesthetic%2C%20film%20poster%20design%2C%20warm%20amber%20tones&width=600&height=900&seq=movie-cover-08&orientation=portrait',
    description: '九十年代的上海，青年阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上，人人都在讲述着他的传奇。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    region: '中国大陆',
    language: '沪语/汉语普通话',
    duration: '30集',
    updateInfo: '王家卫首部电视剧',
    tags: ['年代', '上海', '王家卫', '商战'],
    isHot: true,
    isNew: false,
    viewCount: 16200000,
    content: `<h3>剧集简介</h3>
<p>《繁花》是著名导演王家卫执导的首部电视剧，改编自金宇澄同名小说。该剧以九十年代的上海为背景，讲述了一个关于时代、机遇与命运的故事。</p>

<h3>剧情梗概</h3>
<p>九十年代初的上海，改革开放的浪潮席卷了整个城市。青年阿宝（胡歌 饰）凭借敏锐的商业嗅觉和不懈的努力，从黄河路一家小饭馆的常客，逐步成为叱咤上海滩的商界传奇。在这条充满机遇与挑战的道路上，他结识了精明能干的玲子（马伊琍 饰）、独立自强的汪小姐（唐嫣 饰）以及神秘冷艳的李李（辛芷蕾 饰）。三段截然不同的感情，交织出阿宝跌宕起伏的人生。</p>

<h3>视觉风格</h3>
<p>王家卫标志性的光影美学在《繁花》中得到了充分展现。每一帧画面都经过精心构图和调色，九十年代上海的繁华与怀旧被渲染得淋漓尽致。沪语对白的大量使用，更增添了浓厚的地域特色和真实感。</p>

<h3>观众评价</h3>
<p>"王家卫就是王家卫，每一帧都可以截图当壁纸。"</p>
<p>"胡歌真的太适合阿宝这个角色了，那种上海男人的腔调拿捏得死死的。"</p>
<p>"虽然节奏慢了点，但是越看越上头，最后三集封神。"</p>`,
  },
  {
    id: 9,
    title: '庆余年2',
    subtitle: 'Joy of Life 2',
    category: 'tv',
    subcategory: '古装',
    year: 2024,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20cherry%20blossoms%20falling%2C%20warrior%20in%20traditional%20robes%20holding%20sword%2C%20dramatic%20wuxia%20atmosphere%2C%20cinematic%20lighting%2C%20elegant%20historical%20drama%20style&width=800&height=450&seq=movie-poster-09&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20young%20man%20in%20ancient%20royal%20robe%20with%20confident%20smile%2C%20palace%20background%2C%20dramatic%20composition%2C%20film%20poster%20style&width=600&height=900&seq=movie-cover-09&orientation=portrait',
    description: '范闲从北齐归来后，面临着更加复杂的朝堂斗争和身世之谜。庆帝的态度暧昧不明，各方势力蠢蠢欲动。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '36集',
    updateInfo: '期待已久续作回归',
    tags: ['古装', '权谋', '喜剧', '武侠'],
    isHot: true,
    isNew: true,
    viewCount: 21000000,
    content: `<h3>剧集简介</h3>
<p>《庆余年2》是备受期待的古装权谋大剧续作。延续第一部的故事线，范闲在朝堂和江湖之间游走，展开更加惊心动魄的冒险。</p>

<h3>剧情梗概</h3>
<p>范闲（张若昀 饰）出使北齐归来后，本以为可以安享太平，却发现京都的暗流比之前更加汹涌。庆帝（陈道明 饰）对他的态度愈发难以捉摸，太子与二皇子的争斗进入白热化阶段。与此同时，范闲的身世之谜也逐渐浮出水面——他与皇室的关系远比想象中更加复杂。在各方势力的夹缝中，范闲必须运用自己的智慧和勇气，在权谋的漩涡中杀出一条生路。</p>

<h3>升级亮点</h3>
<p>第二季在保持了第一季轻松幽默风格的同时，加大了权谋戏的比重。陈道明饰演的庆帝戏份大幅增加，与张若昀的对手戏被观众称为"教科书级别的演技对决"。特效和武打场面的制作水准也有明显提升。</p>

<h3>观众评价</h3>
<p>"等了五年终于等到了！范闲还是那个范闲，又欠又可爱。"</p>
<p>"陈道明的庆帝太有压迫感了，每次出场都让人屏住呼吸。"</p>
<p>"第二季的权谋戏比第一季精彩多了，每集都有反转。"</p>`,
  },
  {
    id: 10,
    title: '漫长的季节',
    subtitle: 'The Long Season',
    category: 'tv',
    subcategory: '悬疑',
    year: 2023,
    rating: 9.4,
    image: 'https://readdy.ai/api/search-image?query=Northeast%20China%20industrial%20town%20in%20autumn%2C%20old%20factory%20buildings%20and%20railway%20tracks%2C%20golden%20fall%20leaves%2C%20lonely%20figure%20walking%2C%20melancholic%20mystery%20atmosphere&width=800&height=450&seq=movie-poster-10&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20drama%20TV%20poster%2C%20three%20men%20of%20different%20ages%20standing%20in%20front%20of%20old%20factory%2C%20autumn%20leaves%20falling%2C%20nostalgic%20and%20mysterious%20vibe%2C%20film%20poster%20design&width=600&height=900&seq=movie-cover-10&orientation=portrait',
    description: '一座北方小城，一桩跨越十八年的碎尸悬案。三个不同时代的男人，各自追寻着真相。',
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希', '刘琳'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '12集',
    updateInfo: '口碑封神之作',
    tags: ['悬疑', '年代', '范伟', '催泪'],
    isHot: true,
    isNew: false,
    viewCount: 14300000,
    content: `<h3>剧集简介</h3>
<p>《漫长的季节》是一部口碑炸裂的悬疑剧，由《隐秘的角落》导演辛爽执导。该剧以东北小城为背景，跨越三个年代，讲述了一个关于执念、救赎与和解的故事。</p>

<h3>剧情梗概</h3>
<p>故事围绕一桩发生在东北小城的碎尸案展开，时间线横跨1997年、1998年和2016年。王响（范伟 饰）是一名老火车司机，他的儿子在1998年意外身亡，他始终认为儿子的死与当年的碎尸案有关。十八年来，王响从未放弃追查真相。2016年，当他终于接近真相时，却发现这背后隐藏着一个让他无法接受的秘密。</p>

<h3>艺术成就</h3>
<p>《漫长的季节》以其精妙的叙事结构和深刻的人文关怀，获得了观众和评论界的一致好评。范伟从喜剧演员转型为严肃剧演员的表现令人惊艳，秦昊和陈明昊的表演同样出色。剧中东北工业城市的衰落景象与人物命运相互映照，构成了一个令人动容的时代画卷。</p>

<h3>观众评价</h3>
<p>"看完最后一集哭了半个小时，从来没有一部剧让我这么难过又感动。"</p>
<p>"范伟的演技已经不能用炸裂来形容了，是直达灵魂的震撼。"</p>
<p>"辛爽导演太会讲故事了，三条时间线交错推进，最后汇聚成一把刀子直插心脏。"</p>`,
  },
  {
    id: 11,
    title: '斗罗大陆',
    subtitle: 'Soul Land',
    category: 'anime',
    subcategory: '热血',
    year: 2024,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20world%20with%20floating%20islands%20and%20glowing%20crystals%2C%20young%20warrior%20with%20blue%20energy%20aura%2C%20magical%20academy%20in%20distance%2C%20anime%20style%20scenery%2C%20vibrant%20colors&width=800&height=450&seq=movie-poster-11&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%2C%20young%20boy%20with%20blue%20hair%20and%20martial%20arts%20pose%2C%20glowing%20spirit%20rings%20around%20him%2C%20fantasy%20magical%20background%2C%20anime%20illustration%20style&width=600&height=900&seq=movie-cover-11&orientation=portrait',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志后却来到了另一个世界——斗罗大陆。在这里，他将开启一段传奇旅程。',
    director: '沈乐平',
    actors: ['沈磊', '翟巍', '黄莺'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '更新至263集',
    updateInfo: '国漫顶流持续热播',
    tags: ['国漫', '热血', '玄幻', '顶级制作'],
    isHot: true,
    isNew: false,
    viewCount: 32000000,
    content: `<h3>动画简介</h3>
<p>《斗罗大陆》是根据唐家三少同名小说改编的3D动画，是国产动画的现象级作品。该动画以其精良的制作和忠实原著的改编，赢得了大量粉丝的喜爱。</p>

<h3>剧情梗概</h3>
<p>唐门外门弟子唐三（沈磊 配音），因偷学内门绝学为唐门所不容。他跳崖明志，却意外穿越到了另一个世界——斗罗大陆。在这里，每个人在六岁时都会觉醒武魂，通过修炼不断提升自己的魂力等级。唐三觉醒了两大武魂——蓝银草和昊天锤，由此开启了他在史莱克学院的修炼之路，以及与伙伴们一起对抗武魂殿的冒险旅程。</p>

<h3>制作水准</h3>
<p>《斗罗大陆》动画的制作水准在国内3D动画中处于顶尖水平。角色建模精细，战斗场面流畅，特效华丽而不浮夸。尤其是海神岛篇和嘉陵关大战，其视觉效果甚至可以比肩日本一流动画。</p>

<h3>观众评价</h3>
<p>"国漫天花板！每周必追，唐三和小舞的感情线太好哭了。"</p>
<p>"特效真的越来越好了，海神三叉戟的出场帅炸了。"</p>
<p>"从第一集追到现在，看着制作水平一步步提升，真的很欣慰。"</p>`,
  },
  {
    id: 12,
    title: '奔跑吧·生态篇',
    subtitle: 'Keep Running',
    category: 'variety',
    subcategory: '户外真人秀',
    year: 2024,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20celebrities%20running%20on%20beautiful%20grassland%20with%20blue%20sky%2C%20fun%20variety%20show%20atmosphere%2C%20colorful%20outfits%2C%20sunny%20day%2C%20energetic%20and%20joyful%20vibe&width=800&height=450&seq=movie-poster-12&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20seven%20celebrities%20jumping%20in%20air%20with%20big%20smiles%2C%20colorful%20casual%20outfits%2C%20bright%20sunny%20background%2C%20fun%20energetic%20poster%20design&width=600&height=900&seq=movie-cover-12&orientation=portrait',
    description: '奔跑吧兄弟团再次集结，本季以"生态"为主题，走遍祖国大好河山，在欢笑与挑战中传递环保理念。',
    director: '浙江卫视',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '12期',
    updateInfo: '每周五晚更新',
    tags: ['综艺', '户外', '搞笑', '环保'],
    isHot: false,
    isNew: true,
    viewCount: 5600000,
    content: `<h3>节目简介</h3>
<p>《奔跑吧·生态篇》是浙江卫视王牌综艺节目《奔跑吧》的最新一季。本季以"生态"为主题，兄弟团将走遍祖国大好河山，在趣味游戏中传递环保理念。</p>

<h3>节目特色</h3>
<p>本季节目在保留了经典游戏环节的基础上，增加了大量与生态环保相关的主题内容。兄弟团将深入自然保护区、森林公园等地，通过趣味挑战和互动，向观众展示中国的自然之美，同时普及环保知识。</p>

<h3>成员阵容</h3>
<p>李晨、郑恺、沙溢三位元老继续坐镇，白鹿、周深等新成员带来了全新的活力。成员之间的化学反应和默契配合，是本季节目的最大看点。</p>

<h3>观众评价</h3>
<p>"这季的主题很有意义，寓教于乐，孩子看了也能学到环保知识。"</p>
<p>"周深的综艺感也太强了吧，每期都贡献一堆笑点。"</p>
<p>"景色太美了，看完都想去旅游了。"</p>`,
  },
  {
    id: 13,
    title: '向往的生活·第七季',
    subtitle: 'Back to Field',
    category: 'variety',
    subcategory: '慢综艺',
    year: 2024,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20countryside%20courtyard%20with%20wooden%20house%2C%20vegetable%20garden%20and%20chickens%2C%20mountains%20in%20background%2C%20warm%20sunset%20light%2C%20cozy%20rural%20life%20atmosphere&width=800&height=450&seq=movie-poster-13&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20slow%20life%20variety%20show%20poster%2C%20two%20hosts%20cooking%20in%20rural%20kitchen%20with%20smoke%20rising%2C%20farm%20animals%20around%2C%20peaceful%20countryside%20vibe%2C%20warm%20cozy%20poster%20design&width=600&height=900&seq=movie-cover-13&orientation=portrait',
    description: '黄磊和何炅带着新老朋友，回归田园生活。自己动手，丰衣足食，在慢生活中寻找内心的宁静。',
    director: '湖南卫视',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅', '张子枫'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '14期',
    updateInfo: '告别季温情收官',
    tags: ['综艺', '慢生活', '美食', '治愈'],
    isHot: true,
    isNew: false,
    viewCount: 8900000,
    content: `<h3>节目简介</h3>
<p>《向往的生活》第七季是这档国民慢综艺的告别季。黄磊和何炅再次回归田园，与老友们共度最后的蘑菇屋时光。</p>

<h3>节目特色</h3>
<p>作为中国慢综艺的开创者，《向往的生活》以其独特的"慢"理念赢得了观众的喜爱。没有激烈的竞争，没有刻意的搞笑，只有日出而作、日落而息的简单生活。黄磊的厨艺展示、何炅的温情陪伴、嘉宾们的真诚交流，构成了节目最动人的部分。</p>

<h3>告别季亮点</h3>
<p>本季作为告别季，节目组邀请了前六季中给观众留下深刻印象的嘉宾回归。每一期都是一次温暖的久别重逢。节目中也加入了许多回忆片段，让老观众在笑声中不禁泪目。</p>

<h3>观众评价</h3>
<p>"七年了，蘑菇屋就像一个温暖的家，每个周末都期待回去。"</p>
<p>"黄老师做的每一道菜都让人流口水，何老师的每一个拥抱都治愈人心。"</p>
<p>"告别季看得我哭了好几次，谢谢你们七年的陪伴。"</p>`,
  },
  {
    id: 14,
    title: '凡人修仙传',
    subtitle: 'A Record of a Mortal Journey to Immortality',
    category: 'anime',
    subcategory: '仙侠',
    year: 2024,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Mystical%20Chinese%20mountain%20landscape%20with%20floating%20temples%20and%20waterfalls%2C%20cultivator%20flying%20on%20sword%20through%20clouds%2C%20immortal%20realm%20atmosphere%2C%20anime%20style%2C%20ethereal%20lighting&width=800&height=450&seq=movie-poster-14&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20donghua%20poster%2C%20young%20cultivator%20in%20white%20robe%20holding%20glowing%20sword%2C%20dragon%20spirit%20behind%20him%2C%20mountain%20and%20cloud%20background%2C%20anime%20illustration%20style&width=600&height=900&seq=movie-cover-14&orientation=portrait',
    description: '普通山村少年韩立，凭借坚定的意志和过人的智慧，在残酷的修仙世界中一步步崛起，最终踏上了属于自己的仙途。',
    director: '王裕仁',
    actors: ['钱文青', '赵路', '苏婉'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '更新至72集',
    updateInfo: '口碑持续走高',
    tags: ['国漫', '仙侠', '修仙', '精品制作'],
    isHot: false,
    isNew: false,
    viewCount: 18500000,
    content: `<h3>动画简介</h3>
<p>《凡人修仙传》改编自忘语同名小说，是一部制作精良的3D仙侠动画。以其细腻的情感刻画和宏大的世界观构建，赢得了"国漫仙侠第一"的美誉。</p>

<h3>剧情梗概</h3>
<p>韩立（钱文青 配音）本是山边小村的一名普通少年，因为一次意外被七玄门收为弟子，从此踏上了修仙之路。在尔虞我诈的修仙世界中，韩立凭借着自己的谨慎和智慧，从一介凡人一步步成长为令三界敬畏的强者。从人界到灵界再到仙界，韩立的修仙之路充满了危险与机遇。</p>

<h3>制作特色</h3>
<p>《凡人修仙传》的动画制作注重细节刻画，角色表情丰富自然，战斗场面行云流水。尤其是对修仙世界中各种法术和法宝的视觉呈现，既有中式美学的韵味，又不失现代动画的冲击力。</p>

<h3>观众评价</h3>
<p>"最良心的国漫之一，每集的制作都在进步。"</p>
<p>"韩老魔的谨慎人设太有代入感了，修仙界的生存法则。"</p>
<p>"特效和动作设计完全不输日本动画，国产动画未来可期。"</p>`,
  },
  {
    id: 15,
    title: '封神第一部：朝歌风云',
    subtitle: 'Creation of the Gods I',
    category: 'movie',
    subcategory: '奇幻',
    year: 2023,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battlefield%20with%20thousands%20of%20soldiers%2C%20giant%20mythical%20beasts%20in%20sky%2C%20fantasy%20war%20scene%2C%20dramatic%20lighting%2C%20cinematic%20epic%20scale&width=800&height=450&seq=movie-poster-15&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20film%20poster%2C%20warrior%20king%20on%20throne%20with%20fox%20spirit%20behind%2C%20ancient%20palace%20in%20flames%2C%20dramatic%20red%20and%20gold%20tones%2C%20cinematic%20movie%20poster&width=600&height=900&seq=movie-cover-15&orientation=portrait',
    description: '殷商末年，纣王暴虐无道。姬发觉醒命运之力，率众反抗。一场关于权力、欲望与正义的神话史诗就此展开。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '148分钟',
    updateInfo: '神话史诗三部曲开篇',
    tags: ['奇幻', '神话', '史诗', '封神'],
    isHot: false,
    isNew: false,
    viewCount: 7200000,
    content: `<h3>影片简介</h3>
<p>《封神第一部：朝歌风云》是乌尔善执导的神话史诗三部曲的开篇之作。影片改编自中国古典神魔小说《封神演义》和话本《武王伐纣平话》，以宏大的视角重新诠释了这段家喻户晓的神话传说。</p>

<h3>剧情梗概</h3>
<p>殷商末年，纣王（费翔 饰）在狐妖妲己（娜然 饰）的蛊惑下，暴虐无道，残害忠良。西伯侯姬昌（李雪健 饰）因直言进谏被囚羑里，其子姬发（于适 饰）在昆仑山学艺归来，觉醒了命运之力。与此同时，姜子牙（黄渤 饰）奉元始天尊之命下山封神。一场人、仙、妖三界的大战即将拉开帷幕。</p>

<h3>制作规模</h3>
<p>《封神》三部曲总投资超过30亿人民币，是华语电影史上投资规模最大的项目之一。剧组搭建了超过100个实景和影棚场景，制作了数百套精美戏服和道具。特效由全球顶级团队负责，力求还原中国神话中的奇幻世界。</p>

<h3>观众评价</h3>
<p>"中国终于有了自己的史诗奇幻大片！视觉震撼不输好莱坞。"</p>
<p>"费翔饰演的纣王太有魅力了，那种王者之气扑面而来。"</p>
<p>"期待第二部和第三部，中国神话宇宙搞起来！"</p>`,
  },
  {
    id: 16,
    title: '乘风破浪2024',
    subtitle: 'Sisters Who Make Waves',
    category: 'variety',
    subcategory: '音乐竞演',
    year: 2024,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Women%20performers%20on%20glowing%20stage%20with%20colorful%20spotlights%2C%20music%20competition%20show%20atmosphere%2C%20energetic%20dance%20performance%2C%20entertaining%20vibrant%20stage&width=800&height=450&seq=movie-poster-16&orientation=landscape',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%2C%20group%20of%20female%20celebrities%20in%20stunning%20stage%20outfits%2C%20sparkling%20stage%20lights%2C%20glamorous%20entertainment%20poster%20design&width=600&height=900&seq=movie-cover-16&orientation=portrait',
    description: '来自不同领域的女艺人们齐聚舞台，通过音乐和舞蹈展现女性的力量与魅力，打破年龄的界限，勇敢追梦。',
    director: '芒果TV',
    actors: ['戚薇', '陈丽君', '刘忻', '何洁', '尚雯婕'],
    region: '中国大陆',
    language: '汉语普通话',
    duration: '12期',
    updateInfo: '每周六更新',
    tags: ['综艺', '音乐', '女性', '竞演'],
    isHot: false,
    isNew: true,
    viewCount: 6700000,
    content: `<h3>节目简介</h3>
<p>《乘风破浪2024》是芒果TV推出的女性音乐竞演综艺。节目邀请了来自演艺、歌唱、舞蹈等不同领域的30+女性艺人，通过团队协作和舞台竞演，展现女性无限的可能性。</p>

<h3>节目亮点</h3>
<p>本季节目在赛制上进行了全新升级，增加了更多团队协作和即兴创作的环节。姐姐们不仅要展示唱跳实力，还要参与到舞台设计、编曲改编等创作环节。她们的拼搏精神和舞台表现力，感染了无数观众。</p>

<h3>舞台表现</h3>
<p>本季的舞台设计达到了新的高度，每场演出都是一场视听盛宴。从中国风到未来感，从抒情到炸裂，姐姐们用实力证明：年龄从来不是限制，热爱才是最好的保鲜剂。</p>

<h3>观众评价</h3>
<p>"这一季的姐姐们太拼了，每一期舞台都让人惊艳。"</p>
<p>"看姐姐们在舞台上发光发热，真的很受鼓舞。"</p>
<p>"节目传递的女性力量太正能量了，强烈推荐。"</p>`,
  },
];